import {ErrorHandler, Inject, Injectable} from "@angular/core";
import {ajs_$log_DI_TOKEN, AjsLogService} from "web-ng2/tjenester/ajs/AjsLogService";

/** Global feilhåndtering i ng2.
 * Tilsvarer lederplan-klient/src/scripts/felles/infrastruktur/ExceptionHandler.ts i ajs-verden */
@Injectable()
export class Filehåndtering implements ErrorHandler {

    constructor(@Inject(ajs_$log_DI_TOKEN) private $log: AjsLogService) {
    }

    handleError(error:any) {
        //log til server samt til konsoll
        this.$log.error(error);
    }

}
